import Reveal from "@/components/Reveal";
import { ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    n: "01",
    name: "Deep Tissue Massage",
    desc: "Slow, focused pressure into chronic tension — ideal for persistent neck, shoulder and low-back patterns.",
    meta: "60 / 75 / 90 min",
  },
  {
    n: "02",
    name: "Sports Massage",
    desc: "Pre-event preparation and post-training recovery for runners, cyclists and weekend athletes across Vancouver.",
    meta: "45 / 60 / 90 min",
  },
  {
    n: "03",
    name: "Relaxation & Stress Relief",
    desc: "A nervous-system reset. Flowing, rhythmic work that lowers stress and restores deep, easy breathing.",
    meta: "60 / 90 min",
  },
  {
    n: "04",
    name: "IASTM",
    desc: "Instrument Assisted Soft Tissue Mobilization — precise tool work to release stubborn adhesions and chronic tension.",
    meta: "Within any session",
  },
  {
    n: "05",
    name: "Hot & Cold Stone Therapy",
    desc: "Heated stones melt deep-seated tension while cool stones calm inflammation — temperature therapy woven into your treatment.",
    meta: "Within any session",
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="bg-sand/40 py-24 lg:py-32">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <Reveal>
          <p className="mb-6 flex items-center gap-3 text-xs uppercase tracking-[0.25em] text-clay">
            <span className="h-px w-10 bg-clay" /> Treatments
          </p>
          <div className="flex flex-wrap items-end justify-between gap-8">
            <h2 className="max-w-xl font-serif text-4xl font-light leading-tight tracking-tighter text-forest sm:text-5xl" data-testid="services-heading">
              Sports massage, deep tissue & quiet restoration.
            </h2>
            <p className="max-w-sm text-sm leading-relaxed text-forest/60">
              Every session includes assessment, treatment and home-care guidance.
              30 — 90 minute appointments, from $95.
            </p>
          </div>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-2">
          {SERVICES.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.1} className={i % 2 === 1 ? "md:mt-16" : ""}>
              <a
                href="#visit"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector("#visit")?.scrollIntoView({ behavior: "smooth" });
                }}
                data-testid={`service-${s.n}`}
                className="group block border border-forest/10 bg-bone p-8 transition-all duration-500 hover:-translate-y-2 hover:border-pine/30 hover:shadow-2xl hover:shadow-pine/10 lg:p-12"
              >
                <div className="flex items-start justify-between">
                  <span className="font-serif text-sm italic text-clay">{s.n}.</span>
                  <ArrowUpRight className="h-5 w-5 text-forest/30 transition-all duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-pine" />
                </div>
                <h3 className="mt-10 font-serif text-3xl font-light tracking-tight text-forest lg:text-4xl">{s.name}</h3>
                <p className="mt-4 max-w-md text-sm leading-relaxed text-forest/70">{s.desc}</p>
                <p className="mt-8 text-xs uppercase tracking-[0.2em] text-clay">{s.meta}</p>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
